let lastScroll = 0;
const initFixedMenu = () => {
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  const scrollHandler = () =>{

    const body = document.body;
    const el = document.querySelector('#main')
    let viewportOffset = el.getBoundingClientRect();
    const top = viewportOffset.top;
    const currentScroll = window.scrollY;
    if (currentScroll <= 0) {
      body.classList.remove(scrollUp);
      return;
    }
    if (currentScroll > lastScroll && !body.classList.contains(scrollDown) && (top < 50)) {
      // down
      body.classList.remove(scrollUp);
      body.classList.add(scrollDown);
    } else if ( currentScroll < lastScroll && body.classList.contains(scrollDown)) {
      // up
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
  }
  window.addEventListener("scroll", scrollHandler);
  scrollHandler();
};
export default initFixedMenu;
